import { batteryHeights, batteryPoles } from '@/constants/batteryProduct';

import { ProductBatteryType } from '@/server/services/core/productBattery/models';

export const getBatterySpecs = (product: Pick<ProductBatteryType, 'height' | 'pole' | 'guarantee'>) =>
    [
        batteryHeights[product.height],
        batteryPoles[product.pole],
        product.guarantee ? `گارانتی ${product.guarantee.toLocaleString('fa-IR')} ماه` : ''
    ].filter(Boolean);

export const getBatteryCompatibilityBadge = (isStandard: boolean, vehicleTitle: string) =>
    isStandard
        ? { label: `استاندارد ${vehicleTitle} شما`, tone: 'primary' as const }
        : { label: `قابل نصب روی ${vehicleTitle} شما`, tone: 'neutral' as const };
